export const organizationRouter = [{
    path: '',
    redirect: 'index'
},
    {
        path: 'index',
        meta: {
            title: '首页',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/index'),
    },
    {
        path: 'heart/:type',
        meta: {
            title: '暖心服务',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/heart'),
    },
    {
        path: 'notice/list',
        meta: {
            title: '通知公告',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/notice/list'),
    },
    {
        path: 'notice/adetail/:id',
        meta: {
            title: '通知公告详情',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/notice/adetail'),
    },
    {
        path: 'notice/apply',
        meta: {
            title: '审核列表',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/notice/apply'),
    },
    {
        path: 'notice/edit/:id',
        meta: {
            title: '通知公告编辑',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/notice/edit'),
    },
    {
        path: 'notice/detail/:id',
        meta: {
            title: '通知公告详情',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/notice/detail'),
    },
    {
        path: 'message/list',
        meta: {
            title: '短信群发',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/message/list'),
    },
    {
        path: 'message/send',
        meta: {
            title: '短信群发',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/message/send'),
    },
    {
        path: 'message/remind',
        meta: {
            title: '短信提醒',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/message/remind'),
    },
    {
        path: 'message/remindList',
        meta: {
            title: '提醒记录',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/message/remindList'),
    },
    {
        path: 'email/list',
        meta: {
            title: '邮件群发',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/email/list'),
    },
    {
        path: 'email/setting',
        meta: {
            title: '邮件设置',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/email/setting'),
    },
    {
        path: 'email/send',
        meta: {
            title: '邮件群发',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/email/send'),
    },
    {
        path: 'members/list',
        meta: {
            title: '会员信息',
            needLogin: true , // 是否需要登录才能访问
            keepAlive: true
        },
        component: () =>
            import ('../views/organization/page/members/list'),
    },
    {
        path: 'members/slist',
        meta: {
            title: '会员信息',
            needLogin: true , // 是否需要登录才能访问
            keepAlive: true
        },
        component: () =>
            import ('../views/organization/page/members/slist'),
    },
    {
        path: 'members/draft',
        meta: {
            title: '草稿箱',
            needLogin: true , // 是否需要登录才能访问
            keepAlive: true
        },
        component: () =>
            import ('../views/organization/page/members/draft'),
    },
    {
        path: 'members/sdraft',
        meta: {
            title: '草稿箱',
            needLogin: true , // 是否需要登录才能访问
            keepAlive: true
        },
        component: () =>
            import ('../views/organization/page/members/sdraft'),
    },
    {
        path: 'members/info/:id/:type',
        meta: {
            title: '会员基本信息',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/members/info'),
    },
    {
        path: 'members/certificate/:id',
        meta: {
            title: '会员证书',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/members/certificate'),
    },
    {
        path: 'members/fcertificate/:id',
        meta: {
            title: '分支机构聘书',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/members/fcertificate'),
    },
    {
        path: 'members/exam',
        meta: {
            title: '会员审核',
            needLogin: true, // 是否需要登录才能访问
            keepAlive: true
        },
        component: () =>
            import ('../views/organization/page/members/exam'),
    },
    {
        path: 'members/fexam',
        meta: {
            title: '会员审核',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/members/fexam'),
    },
    {
        path: 'members/examInfo/:id',
        meta: {
            title: '会员信息审核',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/members/examInfo'),
    },

    {
        path: 'members/orgList',
        meta: {
            title: '分支机构管理',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/members/orgList'),
    },
    {
        path: 'members/orgCreat/:id',
        meta: {
            title: '分支机构编辑',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/members/orgCreat'),
    },
    {
        path: 'members/power/:id',
        meta: {
            title: '分支机构权限',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/members/power'),
    },
    {
        path: 'members/orgExam',
        meta: {
            title: '分支机构审核',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/members/orgExam'),
    },
    {
        path: 'members/orgExamInfo/:id',
        meta: {
            title: '分支机构信息审核',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/members/orgExamInfo'),
    },


    {
        path: 'setup/level',
        meta: {
            title: '级别设置',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/setup/level'),
    },
    {
        path: 'setup/flevel',
        meta: {
            title: '级别设置',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/setup/flevel'),
    },
    {
        path: 'setup/label',
        meta: {
            title: '标签设置',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/setup/label'),
    },
    {
        path: 'setup/invitation',
        meta: {
            title: '会员邀请',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/setup/invitation'),
    },
    {
        path: 'setup/binvitation',
        meta: {
            title: '会员邀请',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/setup/binvitation'),
    },
    {
        path: 'setup/information',
        meta: {
            title: '信息设置',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/setup/information'),
    },
    {
        path: 'setup/sinformation',
        meta: {
            title: '信息设置',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/setup/sinformation'),
    },
    {
        path: 'setup/rights',
        meta: {
            title: '信息设置',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/setup/rights'),
    },
    {
        path: 'setup/srights',
        meta: {
            title: '信息设置',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/setup/srights'),
    },
    {
        path: 'setup/explain',
        meta: {
            title: '会员说明',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/setup/explain'),
    },
    {
        path: 'setup/explainArticle/:type/:id',
        meta: {
            title: '会员说明',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/setup/explainArticle'),
    },
    {
        path: 'setup/explainType/:type/:name',
        meta: {
            title: '会员说明',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/setup/explainType'),
    },
    {
        path: 'setup/certificate',
        meta: {
            title: '证书设置',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/setup/certificate'),
    },
    {
        path: 'setup/scertificate',
        meta: {
            title: '证书设置',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/setup/scertificate'),
    },
    {
        path: 'setup/fcertificate',
        meta: {
            title: '证书设置',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/setup/fcertificate'),
    },
    {
        path: 'fee/cost',
        meta: {
            title: '会费管理',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/fee/cost'),
    },
    {
        path: 'fee/fcost',
        meta: {
            title: '分支机构会费管理',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/fee/fcost'),
    },
    {
        path: 'fee/invoice',
        meta: {
            title: '开票记录',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/fee/invoice'),
    },
    {
        path: 'fee/finvoice',
        meta: {
            title: '分支机构开票记录',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/fee/finvoice'),
    },
    {
        path: 'fee/pay',
        meta: {
            title: '支付设置',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/fee/pay'),
    },
    {
        path: 'organ/info',
        meta: {
            title: '组织信息',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/organ/info'),
    },
    {
        path: 'organ/billing',
        meta: {
            title: '费用中心',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/organ/billing'),
    },
    {
        path: 'organ/dynamic',
        meta: {
            title: '组织动态',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/organ/dynamic'),
    },
    {
        path: 'organ/dynamic/apply',
        meta: {
            title: '组织动态',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/organ/dynamic/apply'),
    },
    {
        path: 'organ/dynamic/detail/:id',
        meta: {
            title: '组织动态详情',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/organ/dynamic/detail'),
    },
    {
        path: 'organ/dynamicEdit/:id',
        meta: {
            title: '组织动态',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/organ/dynamicEdit'),
    },
    {
        path: 'organ/activity',
        meta: {
            title: '机构活动 ',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/organ/activity'),
    },
    {
        path: 'organ/server',
        meta: {
            title: '组织服务',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/organ/server'),
    },
    {
        path: 'organ/serverEdit/:id',
        meta: {
            title: '组织服务编辑',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/organ/serverEdit'),
    },
    {
        path: 'organ/serverDetail/:id',
        meta: {
            title: '组织服务详情',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/organ/serverDetail'),
    },
    {
        path: 'organ/account',
        meta: {
            title: '子账号管理',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/organ/account'),
    },
    {
        path: 'members/sonPower/:id',
        meta: {
            title: '子账号管理权限',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
          import ('../views/organization/page/members/sonPower'),
    },
    {
        path: 'organ/password',
        meta: {
            title: '修改密码',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/organ/password'),
    },
    {
        path: 'server/serverList',
        meta: {
            title: '客服管理',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/server/serverList'),
    },
    {
        path: 'server/serverEdit',
        meta: {
            title: '客服编辑',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/server/serverEdit'),
    },
    {
        path: 'server/question',
        meta: {
            title: '常见问题',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/server/question'),
    },
    {
        path: 'server/questionEdit',
        meta: {
            title: '常见问题编辑',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/server/questionEdit'),
    },
    {
        path: 'server/opinion',
        meta: {
            title: '意见反馈',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/server/opinion'),
    },
    {
        path: 'statistics/statistics',
        meta: {
            title: '数据统计',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/statistics/statistics'),
    } ,
    {
        path: 'integral/setting',
        meta: {
            title: '积分设置',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/integral/setting'),
    },
    {
        path: 'feedback',
        meta: {
            title: '意见反馈',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('../views/organization/page/feedback'),
    },
]

export default organizationRouter
